<script>
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";
import { useSharedStore } from "@/stores/shared-store";
import { useCourseFetchStore } from "@/stores/course/course-fetch-store";

export default {
  components: {
    BaseLoading,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 5,
      searchQuery: "",
    };
  },
  computed: {
    sharedStore() {
      return useSharedStore();
    },
    courseFetchStore() {
      return useCourseFetchStore();
    },
    filteredCourses() {
      if (!this.searchQuery) {
        return this.courseFetchStore.courseCreatedList;
      }
      return this.courseFetchStore.courseCreatedList.filter((course) =>
        course.title.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    totalPages() {
      return Math.ceil(this.filteredCourses.length / this.perPage);
    },
    paginatedItem() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredCourses.slice(start, end);
    },
  },
  mounted() {
    this.courseFetchStore.fetchCourseByCreatorList();
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    onSearch() {
      this.currentPage = 1; // reset ke halaman pertama tiap kali search
    },
  },
};
</script>

<template>
  <layouts-header></layouts-header>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2"><!-- Quiz -->Exam</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                <!-- Quiz -->Exam
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="content">
    <div class="container">
      <instructor-header></instructor-header>
      <div class="row">
        <!-- Sidebar -->
        <instructor-sidebar></instructor-sidebar>
        <!-- /Sidebar -->
        <div class="col-lg-9">
          <div
            class="page-title d-flex align-items-center justify-content-between"
          >
            <h5 class="fw-bold"><!-- Quiz -->Exam</h5>
            <div class="tab-list">
              <div class="input-group">
                <span class="input-group-text">
                  <i class="feather-search"></i>
                </span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search courses..."
                  v-model="searchQuery"
                  @input="onSearch"
                />
              </div>
            </div>
          </div>
          <!-- Empty: no courses/exams -->
          <div
            v-if="
              !sharedStore.loading &&
              courseFetchStore.courseCreatedList.length === 0
            "
            class="border rounded-2 p-4 mb-3 text-center"
          >
            <i
              class="isax isax-message-question5 text-muted d-block mb-3"
              style="font-size: 2.5rem"
            ></i>
            <h6 class="text-muted mb-1">Belum ada exam</h6>
            <p class="text-muted fs-14 mb-0">
              Exam dari course yang kamu buat akan muncul di sini. Buat course
              dan tambahkan exam dulu ya.
            </p>
          </div>

          <!-- Empty: search no results -->
          <div
            v-else-if="
              !sharedStore.loading &&
              searchQuery &&
              filteredCourses.length === 0
            "
            class="border rounded-2 p-4 mb-3 text-center"
          >
            <i
              class="isax isax-search-normal-1 text-muted d-block mb-3"
              style="font-size: 2.5rem"
            ></i>
            <h6 class="text-muted mb-1">Tidak ada course ditemukan</h6>
            <p class="text-muted fs-14 mb-0">
              Tidak ada hasil untuk “{{ searchQuery }}”. Coba kata kunci lain
              atau hapus pencarianmu.
            </p>
          </div>

          <!-- Course exam list -->
          <template v-else>
            <div
              class="border rounded-2 p-3 mb-3"
              v-for="(item, index) in paginatedItem"
              :key="index"
            >
              <div class="row align-items-center">
                <div class="col-md-8">
                  <div>
                    <h6 class="mb-2">
                      <router-link
                        :to="`/instructor/instructor-exam-submission/${item.exam.examID}`"
                        >{{ item.title }}</router-link
                      >
                    </h6>
                    <div class="question-info d-flex align-items-center">
                      <p
                        class="d-flex align-items-center fs-14 me-2 pe-2 border-end mb-0"
                      >
                        <i
                          class="isax isax-message-question5 text-primary-soft me-2"
                        ></i
                        >{{ item.submission_count }} Submission
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div
                    class="d-flex align-items-center justify-content-end mt-2 mt-md-0"
                  >
                    <router-link
                      :to="`/instructor/instructor-exam-submission/${item.exam.examID}`"
                      class="text-info text-decoration-underline fs-12 fw-medium me-3"
                      >View Results</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- /pagination -->
          <div class="row align-items-center mt-3" v-if="totalPages > 1">
            <div class="col-md-2">
              <p class="pagination-text">
                Page {{ currentPage }} of {{ totalPages }}
              </p>
            </div>
            <div class="col-md-10">
              <ul
                class="pagination lms-page justify-content-center justify-content-md-end mt-2 mt-md-0"
              >
                <li
                  class="page-item prev"
                  :class="{ disabled: currentPage === 1 }"
                >
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    tabindex="-1"
                    @click="goToPage(currentPage - 1)"
                    ><i class="fas fa-angle-left"></i
                  ></a>
                </li>
                <li
                  class="page-item"
                  v-for="page in totalPages"
                  :key="page"
                  :class="{ active: currentPage === page }"
                >
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    @click="goToPage(page)"
                  >
                    {{ page }}</a
                  >
                </li>
                <li
                  class="page-item next"
                  :class="{ disabled: currentPage === totalPages }"
                >
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    @click="goToPage(currentPage + 1)"
                    ><i class="fas fa-angle-right"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
          <!-- /pagination -->
        </div>
      </div>
    </div>
  </div>
  <!-- <footer-two></footer-two> -->
  <BaseLoading v-show="sharedStore.loading"></BaseLoading>
</template>
